import { useUtils } from "@/app/hooks/useUtils";
import { Switch } from "@headlessui/react";
import { useEffect, useState } from "react";
import { IToggleProps } from "./interface";

const Toggle: React.FC<IToggleProps> = (props) => {
  const { classNames } = useUtils();
  const [enabled, setEnabled] = useState(false);

  // Callback function that returns the state value
  const handleToggle = () => {
    setEnabled(!enabled); // Toggle the state
    if (props.onToggle) {
      props.onToggle(!enabled);
    }
  };

  useEffect(() => {
    if (props.checked !== undefined) {
      setEnabled(props.checked);
    }
  }, [props.checked]);

  useEffect(() => {
    if (props?.flage) setEnabled(props?.flage);
  }, [props?.flage]);

  return (
    <Switch.Group as="div" className="flex items-center">
      <Switch
        disabled={props?.disabled === true ? true : false}
        checked={enabled}
        onChange={handleToggle} // Call the callback function when the switch is toggled
        className={classNames(
          enabled ? props?.className ?? "bg-[var(--color-primary)]" : "bg-gray-200",
          "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ",
        )}
      >
        {({ checked }) => (
          <span
            aria-hidden="true"
            className={classNames(
              checked ? "translate-x-5" : "translate-x-0",
              "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
            )}
          />
        )}
      </Switch>
      {props?.switchLabel && (
        <Switch.Label as="span" className="ml-3 text-sm">
          <span className="font-medium text-gray-900">{props?.switchLabel?.title}</span>{" "}
        </Switch.Label>
      )}
    </Switch.Group>
  );
};

export default Toggle;
